<template>
  <div v-if="amReady">
    <div class="p-3">
      <div class="mb-4 ">
        <div class="title text-uppercase text-left  d-inline-block" v-if="formHeader">{{ this.getFormTitle }}</div>

        <dg-button :click="createModule" :icon="actionButtonIcon" :loading="requestOn" :text="actionButtonLabel"
                   :translate="false"
                   :type="actionButtonType" class="float-right d-inline-block" fieldSize="mini"
                   v-if="editable"></dg-button>
      </div>

      <div class="border-top pt-3">
        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-select-field
                :control="control"
                :field_span="22"
                :label_span="22"
                :options="unTakenFusionServers"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Fusion"
                name="fusion_server_id"
                rules="required"></dg-select-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-text-field
                :control="control"
                :editable="editable"
                :field_span="22"
                :label_span="22"
                :translateLabel='false'
                field_mark="required"
                label="Title"
                name="title"
                placeholder="CC China"
                rules="required">
            </dg-text-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-text-field
                :control="control"
                :defaultValue="lastUsedLoopDelay"
                :editable="editable"
                :field_span="22"
                :label_span="22"
                :translateLabel='false'
                field_mark="required"
                label="Dialer Loop Delay"
                name="loop_delay_in_ms"
                placeholder="5"
                rules="required">
            </dg-text-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-text-field
                :control="control"
                :defaultValue="lastUsedDialingDelay"
                :editable="editable"
                :field_span="22"
                :label_span="22"
                :translateLabel='false'
                field_mark="required"
                label="Calls Interval"
                name="delay_between_calls_in_ms"
                placeholder="1"
                rules="required">
            </dg-text-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-text-field
                :control="control"
                :editable="editable"
                :field_span="22"
                :label_span="22"
                :translateLabel='false'
                field_mark="optional"
                label="Digits Between"
                name="format_numbers_digits_between"
                placeholder=""
                rules="optional">
            </dg-text-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-number-field
                :control="control"
                :defaultValue="1"
                :editable="editable"
                :field_span="22"
                :label_span="22"
                :max="32"
                :min="1"
                :translateLabel='false'
                field_mark="required"
                label="Ports"
                name="number_of_ports"
                rules="required"></dg-number-field>
          </el-col>
        </el-row>
        <el-row>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-select-field
                :control="control"
                :field_span="22"
                :label_span="22"
                :options="$store.state['voip-rate-division-api'].getDropDownSipList"
                :translateLabel="false"
                :translateLabels="false"
                @amUpdated="divisionUpdated"
                field_mark="required"
                label="Division"
                name="division_id"
                rules="required"></dg-select-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-select-field
                :control="control"
                :field_span="22"
                :label_span="22"
                :options="$store.state['voip-destination-api'].getDropDownSipList"
                :translateLabel="false"
                :translateLabels="false"
                @amUpdated="destinationUpdated"
                class="mt-0 mb-0"
                field_mark="required"
                htmlautocomplete="new-password"
                label="Destination"
                labelProperty="label"
                name="destination_id"
                placeholder="Canada / ATI"
                rules="required"
                valueProperty="value"
            ></dg-select-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-select-field
                :control="control"
                :field_span="22"
                :label_span="22"
                :options="destinationRateDropDownList"
                :translateLabel="false"
                :translateLabels="false"
                @amUpdated="rateUpdated"
                :whenUpatedParams.sync="destinationRateDropDownList"
                class="mt-0 mb-0"
                field_mark="required"
                label="Rate"
                name="rate_id"
                rules="required"></dg-select-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-select-field
                :control="control"
                :field_span="22"
                :label_span="22"
                :options="userTestingPanelSetting"
                :translateLabel="false"
                :translateLabels="false"
                class="mt-0 mb-0"
                field_mark="required"
                label="Test Type"
                name="call_test_type"
                rules="required"></dg-select-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-text-field
                :control="control"
                :editable="editable"
                :field_span="22"
                :label_span="22"
                :translateLabel='false'
                field_mark="required"
                label="Caller ID"
                name="caller_id"
                placeholder="11284825829"
                rules="required"></dg-text-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-radio-field
                :control="control"
                :defaultValue="1"
                :field_span="22"
                :label_span="22"
                :options="radioOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Start Directly"
                name="start_after_creation"
                rules="required"></dg-radio-field>
          </el-col>
          <!--<el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-radio-field
                :control="control"
                :defaultValue="1"
                :field_span="22"
            :label_span="22"
                :options="radioOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Use Top Destinations"
                name="using_only_top_destinations"
                rules="required"></dg-radio-field>
          </el-col>-->
        </el-row>

        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
            <dg-text-field
                :control="control"
                :field_span="22"
                :label_span="24"
                :translateLabel="false"
                class="mt-0 pt-0"
                field_mark="required"
                field_master_container_style="margin-bottom:0px;"
                label="Phone Numbers"
                name="bc_phone_numbers"
                placeholder="00123 456 789, 0012456 7890"
                rows="6"
                rules="required"
                type="textarea">
              <template slot="field_note">
                <sub>phone numbers separated with comma " , "</sub>
              </template>
            </dg-text-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
            <dg-text-field
                :control="control"
                :field_span="22"
                :label_span="24"
                :translateLabel="false"
                class="mt-0 pt-0"
                field_mark="optional"
                field_master_container_style="margin-bottom:0px;"
                label="Numbers to Format"
                name="phone_numbers_to_format"
                placeholder=""
                rows="6"
                rules="optional"
                type="textarea">
              <template slot="field_note">
                <sub>phone numbers to format with digits between</sub>
              </template>
            </dg-text-field>

            <el-button size="small" type="primary" @click="formatNumbersToPhoneNumbers">Format Numbers</el-button>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="24" class="mt-2">
            <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
              <label class="error-field-validate-message text-capitalize"
                     v-show="!this.validData">{{
                  (requestErrorMessage) ? $ml.get(requestErrorMessage) : $ml.get('fields_do_not_match_the_required_criteria')
                }}</label>
            </el-col>
            <el-col :span="12" class="pt-3 text-right">
              <dg-confirm-button
                  :loading="requestOn"
                  :onConfirm="moduleDeleteAction"
                  :translate="false"
                  class="mr-2"
                  confirmButtonType="danger"
                  fieldSize="mini"
                  icon="el-icon-delete"
                  popIcon="el-icon-delete"
                  text="remove"
                  title="sure to removing this record ?"
                  type="danger"
                  v-if="editMode"></dg-confirm-button>

              <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                         type="warning" v-if="editable && editMode"></dg-button>
              <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                         v-if="!editable && editMode"></dg-button>


              <!--<dg-confirm-button
                  :icon="actionButtonIcon"
                  :loading="requestOn"
                  :onConfirm="createModule"
                  :text="actionButtonLabel"
                  :translate="false"
                  :type="actionButtonType"
                  fieldSize="mini"
                  v-if="editable"></dg-confirm-button>-->
            </el-col>
          </el-col>
        </el-row>
      </div>

    </div>
    <hr>
    <el-row>
      <el-col :span="4">
        Digits Between
      </el-col>
      <el-col :span="18">
        <i class="ml-2" style="font-size: 10pt;text-align: justify;word-break: break-word">These digits will be set
          between vendor prefix and the dialed number</i>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4">
        Calls Interval
      </el-col>
      <el-col :span="18">
        <i class="ml-2" style="font-size: 9pt;text-align: justify;word-break: break-word">1 000 000 (1 million) => 1
          second</i>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import module from './../index.js'

import {notify, notifySuccess, notifyDanger} from '@/system-services/notify.js'

import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import moduleForm from '@/modules-config/mixins/moduleForm.js';
import moduleFormProps from '@/modules-config/mixins/moduleFormProps.js';
import panelMixin from '@/app/portals/cpanel/mixins/util'

export default {
  beforeMount() {
    this.getFormData()
  },
  data() {
    return {
      selectedRate: null,
      destinationRateDropDownList: [],
      userTestingPanelSetting: [],
      destinationsDropDownList: [],
      unTakenFusionServers: [],
      lastUsedLoopDelay: 5,
      lastUsedDialingDelay: 1,
      currentRunningTestId: null,
      automationTestLog: [],
      abilityToMakeNewTest: {},
      isTestTakingActions: 0,
      module: {...module},
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      requestErrorMessage: null,
      selectedRatePrefix: false,
      radioOptions: [
        {
          label: 'Yes',
          value: 1,
          link_label: ''
        },
        {
          label: 'No',
          value: '0',
          link_label: ''
        }
      ],
      intervalHandler: null,
      intervalHandlerTakingAction: null
    }
  },
  methods: {
    formatNumbersToPhoneNumbers () {
      let numbersToFormat = this.dataModel.phone_numbers_to_format
      if (numbersToFormat.length == 0) return
      let cleanWhiteSpaced = numbersToFormat.replace(/\s+/g, ',')
      this.fields['bc_phone_numbers'].field.setValue(cleanWhiteSpaced)

      let digitsBetween = this.dataModel.format_numbers_digits_between
      if (!digitsBetween) return

      let arrayOfNumbers = cleanWhiteSpaced.split(',')
      let arrayOfPrefixes =  digitsBetween.replace(/\s+/g, '').split(',')
      let formattedNumbers = ''
      let lenOfDigitsBetween = arrayOfPrefixes.length

      for (let i = 0; i < lenOfDigitsBetween; i++) {
        formattedNumbers += this.addDigitsBetweenToNumbers(arrayOfNumbers, arrayOfPrefixes[i])
      }
      this.fields['bc_phone_numbers'].field.setValue(formattedNumbers.slice(0, -1))
    },
    addDigitsBetweenToNumbers(numbers, preNum) {
      let len = numbers.length
      let out = ''
      for (let i = 0; i < len; i++) {
        out += preNum + numbers[i] + ','
      }

      return out
    },
    ...$mapActions('voip-destination-api', {getDestinationsDropDownList: 'getDropDownSipList'}),
    ...$mapActions('voip-rate-division-api', {getDropDownSipList: 'getDropDownSipList'}),
    ...$mapActions('voip-fusion-server-api', {dropDownUnTakenBySipDialer: 'dropDownUnTakenBySipDialer'}),
    ...$mapActions('voip-testing-panel-api', {
      getUserTestingPanelTestTypes: 'getUserTestingPanelTestTypes',
      getRatePanelInfo: 'getRatePanelInfo'
    }),
    rateUpdated(inputField, params) {
      let val = inputField.field.field_value
      let options = inputField.params
      let label = false
      for (let x in options) {
        if (options[x].value == val) label = options[x].label
      }
      if (val) {
        this.selectedRate = val
        /*this.getRatePanelInfo({rateId: value}).then((r) => {
          this.selectedRateStatus = r.data.call_test_status_id
          this.selectedRateEffectiveDate = r.data.effective_date
        })*/
      }
      if (label) {
        label = label.split(' ')
        label = label[label.length-1]
        this.selectedRatePrefix = label
      } else {
        this.selectedRatePrefix = false
      }
    },
    destinationUpdated(field) {
      let val = field.field.field_value

      if (!val) return
      this.selectedRate = null

      this.dataModel.destination_id = field.field.field_value
      this.panelMixin_getDestinationRate({
        id: val,
        divisionId: this.dataModel.division_id,
        vendor_id: this.selectedVendor
      }, (r) => {
        this.destinationRateDropDownList = r
        this.defaultRateValue = null
      })

      if (this.fields.hasOwnProperty('rate_id')) {
        this.fields['rate_id'].field.field_value = ''
        this.fields['rate_id'].field.updateValue()
        this.fields['rate_id'].field.validateMessage = ''
      }

      this.selectedRateStatus = null
    },
    divisionUpdated(inputField) {
      let selectedDivision = inputField.field.field_value

      this.dataModel.destination_id = null
      if (this.fields.hasOwnProperty('destination_id')) {
        this.fields['destination_id'].field.field_value = ''
        this.fields['destination_id'].field.updateValue()
        this.fields['destination_id'].field.validateMessage = ''
      }

      this.dataModel.rate_id = null
      if (this.fields.hasOwnProperty('rate_id')) {
        this.fields['rate_id'].field.field_value = ''
        this.fields['rate_id'].field.updateValue()
        this.fields['rate_id'].field.validateMessage = ''
      }

      this.selectedRateStatus = null
    },
    getUnTakenBySipDialer() {
      this.dropDownUnTakenBySipDialer({}).then(r => {
        this.customerunTakenFusionServersList = r
      })
    },
    IsJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false;
      }
      return true;
    },
    getFormData() {
      this.dataModel.delay_between_calls_in_ms = this.lastUsedDialingDelay
      let promises = []
      promises.push(this.getDropDownSipList().then(r => {
      }))
      promises.push(this.getDestinationsDropDownList().then(r => {
      }))
      promises.push(this.dropDownUnTakenBySipDialer().then(r => {
        this.unTakenFusionServers = r
      }))

      this.getUserTestingPanelTestTypes().then((r) => {
        this.userTestingPanelSetting = r.data
      })

      Promise.all(promises).then((values) => {
        this.amReady = true
        $vue.nextTick(() => {
          this.bindController()
        })
      })
    },

    async createModule() {
      this.validateFields().then(async result => {
        if (!result) {
          this.requestErrorMessage = null;
          return
        }

        //this.requestOn = true
        let context = this;
        let apiMethod = (this.editMode) ? 'update' : 'create';
        let apiParams = {data: {...this.dataModel}};
        if (this.editMode) apiParams.id = this.dataToBind.id;

        this.$store.dispatch('voip-sip-dialer-api/' + apiMethod, apiParams).then(response => {
          this.amReady = false
          notifySuccess((apiMethod == 'update') ? 'Created' : 'Created')

          $vue.nextTick(() => {
            context.amReady = true
            if (context.editMode) {
              alert('p91')
              if (context.onEditCallback) context.onEditCallback(response.data)
            } else {
              alert('p92')
              if (context.onCreateCallback) context.onCreateCallback(response.data)
            }
          })

        }).catch(error => {
          let context = this;
          this.amReady = false
          $vue.nextTick(() => {
            context.amReady = true
            if (context.editMode) {
              if (context.onEditCallback) context.onEditCallback()
            } else {
              if (context.onCreateCallback) context.onCreateCallback()
            }
          })

          notify({
            type: 'success',
            title: 'Created',
          });
          /*if (this.IsJsonString(responseData)) {
            let status = responseData.status

            if (status == 200) {
              alert('p2')
              this.amReady = false
              $vue.nextTick(() => {
                context.amReady = true
                if (context.editMode) {
                  alert('p3')
                  if (context.onEditCallback) context.onEditCallback(response.data)
                } else {
                  alert('p4')
                  if (context.onCreateCallback) context.onCreateCallback(response.data)
                }
              })
              alert('p5')

              notify({
                type: 'success',
                title: 'Created',
              });
            } else {
              notify({
                type: 'error',
                title: 'Failed',
              });
            }
          } else {
            notify({
              type: 'error',
              title: 'Failed',
            });
            console.log('catch error', error)
          }*/
          /*
          this.validData = false
          if (error.response.data.errorMessage) {
            this.requestErrorMessage = error.response.data.errorMessage
          } else {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            });
          }*/
        }).finally(() => {
          this.requestOn = false
        })
      })
    }
  },
  mixins: [fieldController, moduleForm, moduleFormProps, panelMixin],
}
</script>

<style scoped>
.automated-test-log {
  font-size: 11pt;
  border-bottom: 1px solid #ccc;
  padding: 5px 0;
  margin-bottom: 5px;;
}
</style>
